/* eslint-disable max-len */
import handsAboveBall from 'core/common/assets/images/hands_above_ball.png';
import { TechLayout } from 'core/common/ui/layouts';
import { Typography } from 'core/common/ui/ui-kit';
import { SupportBotButton } from 'core/common/ui/widgets';
import { Benefits, FeedbackCards, Partners } from '../FlowSections';
import { useHome } from './useHome';
import { ContainerStyled, SectionStyled, TitleStyled, ButtonStyled, ImageStyled } from './styled';

const contentPartners = {
  list: [
    {
      alt: 'New Tork Times',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/new-york-times.png',
      width: 212,
      height: 30,
    },
    {
      alt: 'Lifewire',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/lifewire.png',
      width: 90,
      height: 20,
    },
    {
      alt: 'Refinery',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/refinery.png',
      width: 162,
      height: 32,
    },
    {
      alt: 'Bustle',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/bustle.png',
      width: 89,
      height: 24,
    },
    {
      alt: 'Urban',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/urban-list.png',
      width: 104,
      height: 36,
    },
    {
      alt: 'Beebom',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/beebom.png',
      width: 112,
      height: 22,
    },
    {
      alt: 'Hypebae',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/hypebae.png',
      width: 90,
      height: 24,
    },
    {
      alt: 'WellGood',
      src: 'https://media.appnebula.co/fb-gallery/compatibility/well-good.png',
      width: 288,
      height: 16,
    },
  ],
  title: 'As featured in',
};

const contentBenefits = {
  list: [
    'Your personalised plan',
    '1:1 advice from your own psychic',
    'Finding the most compatible partner',
    'Insights into your relationship patterns,and emotional and sexual needs',
    'Better understanding of yourself',
  ],
  title: 'What you get',
};

const contentFeedbackCards = {
  list: [
    {
      date: '18/06/2024',
      review:
        'Anxiety controlled my relationships, leaving me stuck. This plan helped me let go of overthinking, and now I’m confident and open to real love.',
      userName: 'Jeanne MacKey, 32',
      verified: {
        icon: {
          alt: 'Verified icon',
          src: 'https://media.appnebula.co/icons/VerifiedRounded.svg',
        },
        text: 'Verified user',
      },
    },
    {
      date: '26/07/2024',
      review:
        "Anxiety used to control my relationships, the plan has turned the tables. I've stopped overthinking and opened my heart.",
      userName: 'Brandy Hess, 37',
      verified: {
        icon: {
          alt: 'Verified icon',
          src: 'https://media.appnebula.co/icons/VerifiedRounded.svg',
        },
        text: 'Verified user',
      },
    },
    {
      date: '02/04/2024',
      review:
        'My marriage was suffering from mistrust. The plan provided practical techniques for navigating tough conversations.',
      userName: 'Ingrid McCarty, 40',
      verified: {
        icon: {
          alt: 'Verified icon',
          src: 'https://media.appnebula.co/icons/VerifiedRounded.svg',
        },
        text: 'Verified user',
      },
    },
  ],
  title: 'Users love us',
};

type HomeProps = {
  funnelName: string;
};

export const Home = ({ funnelName }: HomeProps) => {
  const { startQuiz } = useHome(funnelName);

  return (
    <TechLayout>
      <ContainerStyled maxWidth={'container'}>
        <SectionStyled>
          <TitleStyled variant="h1">
            Navigate life&apos;s challenges with the astrology as your guide
          </TitleStyled>
          <TitleStyled variant="h4">
            Start your self-discovery journey today by completing our quiz and receiving a tailored
            plan just for you
          </TitleStyled>
          <ButtonStyled variant="contained" onClick={startQuiz}>
            Start
          </ButtonStyled>
          <TitleStyled variant="h2" gutterBottom textAlign="center">
            Step into the world of Hyper-personalized Astrology
          </TitleStyled>
          <ImageStyled src={handsAboveBall} height={217} width={352} alt="hands above the ball" />
          <Typography variant="bodyMediumRegular">
            Nebula combines data from different sources to create a personalized astrological
            blueprint, while offering friendly and enjoyable guidance from professional astrologers.
            Its approach ensures personalized insights that make exploring astrology both fun and
            accessible.
          </Typography>
        </SectionStyled>
        <SectionStyled>
          <Benefits content={contentBenefits} />
        </SectionStyled>
        <SectionStyled>
          <Partners content={contentPartners} />
        </SectionStyled>
        <SectionStyled>
          <FeedbackCards content={contentFeedbackCards} />
        </SectionStyled>
        <SupportBotButton variant="fixed" buttonText="Help" />
      </ContainerStyled>
    </TechLayout>
  );
};
